module.exports = __webpack_public_path__ + "img/A-01.40a925de.png";